import React from "react";
import { Card } from "antd";
import ReportCardTitle from "../shared/ReportCardTitle/ReportCardTitle";
import { TopKeywordsReportContainer } from "../../containers/TopKeywords";
import "./KeywordResearch.less";

function KeywordResearchLayout(props) {
  return (
    <Card data-cy="keywords-research-table" title={<ReportCardTitle title={props.title} domain={props.domain} />}>
      <TopKeywordsReportContainer
        domain={props.domain}
        seoDb={props.seoDb}
        orderBy={props.orderBy}
        orderDir={props.orderDir}
        showSuggestions={true}
      />
    </Card>
  );
}

export default KeywordResearchLayout;
